import type { ChannelType } from '@lagerfeuer/shared';
import { Folder, Hash, Lock, Megaphone, MessagesSquare, Users, Volume2 } from 'lucide-react';

/** Symbol je Kanaltyp (eigene Auswahl, keine fremden Assets). */
export function ChannelIcon({ type, size = 18, locked }: { type: ChannelType; size?: number; locked?: boolean }) {
  const props = { size, 'aria-hidden': true as const, className: 'channel-icon' };
  if (locked && (type === 'TEXT' || type === 'PRIVATE_THREAD')) return <Lock {...props} />;
  switch (type) {
    case 'VOICE':
      return <Volume2 {...props} />;
    case 'ANNOUNCEMENT':
      return <Megaphone {...props} />;
    case 'FORUM':
      return <MessagesSquare {...props} />;
    case 'CATEGORY':
      return <Folder {...props} />;
    case 'GROUP_DM':
      return <Users {...props} />;
    case 'PUBLIC_THREAD':
    case 'PRIVATE_THREAD':
      return <MessagesSquare {...props} />;
    default:
      return <Hash {...props} />;
  }
}

export const CHANNEL_TYPE_LABELS: Record<ChannelType, string> = {
  TEXT: 'Textkanal',
  VOICE: 'Sprachkanal',
  CATEGORY: 'Kategorie',
  ANNOUNCEMENT: 'Ankündigungen',
  FORUM: 'Forum',
  DM: 'Direktnachricht',
  GROUP_DM: 'Gruppe',
  PUBLIC_THREAD: 'Thread',
  PRIVATE_THREAD: 'Privater Thread',
};
